import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { PolicyInfo } from './app.models';

const httpOptions: { headers; } = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class PolicyInfoService {
  constructor(private http: HttpClient) { }

  public getPolicyInfo(hash: string, queryUrl: string): Observable<PolicyInfo> {
    return new Observable((observer: Observer<PolicyInfo>) => {
      this.GetPolicyInformation(hash, queryUrl)
        .subscribe(d => {
          const policyInfo = this.MapResponseToPolicyInfo(d);
          observer.next(policyInfo);
          observer.complete();
        });
    });
  }

  private MapResponseToPolicyInfo(d: any): PolicyInfo {
    if (d.data.Policy != null) {
      return {
        MonthlyPremium: d.data.Policy.MonthlyPremium,
        FaceAmount: d.data.Policy.FaceAmount,
        CoverageLength: d.data.Policy.CoverageLength,
        FirstName: d.data.Policy.Lead.FirstName,
        MiddleInitial: d.data.Policy.Lead.MiddleInitial,
        LastName: d.data.Policy.Lead.LastName,
        EmailAddress: d.data.Policy.Lead.EmailAddress,
        ZipCode: d.data.Policy.Lead.ZipCode,
        City: d.data.Policy.Lead.City,
        State: d.data.Policy.Lead.State.Abbreviation,
        PhoneNumber: d.data.Policy.Lead.Phones[0].PhoneNumber
      };
    }
  }

  private GetPolicyInformation(hash: string, url: string): Observable<PolicyInfo> {
    return this.http.get<any>(url + hash, httpOptions);
  }

}
